/**
 * Los meses en que se puede abrir un bloque.
 *
 * El bloque es el mes de las ALTAS, no el mes en que se trabaja: el acta lo
 * imprime como «periodo de vinculación» y el tope de 150 legajos se cuenta por
 * el semestre de ese mes. Las altas de un mes recién están completas cuando el
 * mes cierra —el padrón de setiembre se carga en octubre—, así que se propone
 * el último mes cerrado. El mes en curso sigue disponible, porque no está
 * fijado si hay un cierre formal del mes (`SN-3`), y también los anteriores,
 * para ponerse al día con un mes atrasado.
 *
 * Se calcula sobre la cadena `AAAA-MM-DD`, sin `Date`, por lo mismo que
 * `fecha()` (`COD-3`): un desfase de zona horaria cambiaría el mes.
 */

/** Cuántos meses se ofrecen, contando el actual. */
export const MESES_ABRIBLES = 6

/** `AAAA-MM` del mes que está `atras` meses antes del de `hoy` (`AAAA-MM-DD`). */
function mesAtras(hoy: string, atras: number): string {
  const indice = Number(hoy.slice(0, 4)) * 12 + Number(hoy.slice(5, 7)) - 1 - atras
  return `${String(Math.floor(indice / 12))}-${String((indice % 12) + 1).padStart(2, '0')}`
}

export interface PeriodosParaAbrir {
  /** Los meses sin bloque, del más reciente al más antiguo. */
  libres: readonly string[]
  /**
   * El que se propone: el último mes cerrado; si ya tiene bloque, el mes en
   * curso; si también, el más reciente que quede libre.
   */
  propuesto: string | undefined
}

export function periodosParaAbrir(hoy: string, existentes: Iterable<string>): PeriodosParaAbrir {
  const ocupados = new Set(existentes)
  const recientes = Array.from({ length: MESES_ABRIBLES }, (_, atras) => mesAtras(hoy, atras))
  const libres = recientes.filter((periodo) => !ocupados.has(periodo))
  const [actual = '', cerrado = ''] = recientes
  const propuesto = [cerrado, actual, ...libres].find((periodo) => libres.includes(periodo))
  return { libres, propuesto }
}
